import gql from 'graphql-tag';

const KEY_ACTIVITIES_COMPLETED_AND_TIME_SPENT_REPORT_QUERY = gql`
  query keyActivitiesCompletedAndTimeSpentReport(
    $where: KeyActivitiesCompletedAndTimeSpentReportWhereInput!
    $dateRange: DateRangeInput!
  ) {
    keyActivitiesCompletedAndTimeSpentReport(where: $where, dateRange: $dateRange) {
      intervalUnit
      intervals {
        interval
        averageMinutesSpent
        activitiesCompletedCount
      }
      totalActivitiesCompletedCount
      averageWeeklyMinutesSpent
    }
  }
`;

export default KEY_ACTIVITIES_COMPLETED_AND_TIME_SPENT_REPORT_QUERY;
